import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';

const MAX_FILE_SIZE = 5 * 1024 * 1024 * 1024; // 5GB

const VideoUpload = ({ onVideoSelect }) => {
  const [error, setError] = useState('');
  
  const onDrop = useCallback((acceptedFiles) => {
    setError('');
    
    // Handle the uploaded files
    if (acceptedFiles && acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      
      // Check file size
      if (file.size > MAX_FILE_SIZE) {
        setError(`File is too large. Maximum size is 5GB.`);
        return;
      }
      
      // Check file type
      const validTypes = ['video/mp4', 'video/avi', 'video/quicktime', 'video/x-ms-wmv', 'video/x-matroska', 'video/webm'];
      if (!validTypes.includes(file.type)) {
        setError('Please upload a valid video file (MP4, AVI, MOV, WMV, MKV, WEBM)');
        return;
      }
      
      // Pass the file to parent component
      onVideoSelect(file);
    }
  }, [onVideoSelect]);
  
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'video/*': ['.mp4', '.avi', '.mov', '.wmv', '.mkv', '.webm']
    },
    maxFiles: 1
  });
  
  return (
    <div className="mb-4">
      <div 
        {...getRootProps()} 
        className={`dropzone ${isDragActive ? 'active' : ''}`}
        style={{
          borderColor: error ? '#dc3545' : isDragActive ? '#0d6efd' : '#ced4da'
        }}
      >
        <input {...getInputProps()} />
        <div className="mb-3">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-camera-video" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5zm11.5 5.175 3.5 1.556V4.269l-3.5 1.556v4.35zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2z"/>
          </svg>
        </div>
        <p>
          {isDragActive ? 
          'Drop the video here...' : 
          'Drag and drop a video file here, or click to select a file'}
        </p>
        <p className="text-muted small">Supported formats: MP4, AVI, MOV, WMV, MKV, WEBM (max 5GB)</p>
      </div>
      
      {error && <div className="alert alert-danger">{error}</div>}
      
      <div className="notice">
        <strong>Important:</strong> The Gemini AI model can only process videos up to 55 minutes in length.
        Longer videos will fail to process.
      </div>
    </div>
  );
};

export default VideoUpload;